import { useEffect, useState } from 'react';
import {
  ZOLA_PLP_PHOTO_PREVIEW,
  SUPPORTED_CARD_TYPES,
} from 'cards/components/CardListing/PhotoPreview';

export interface SessionData {
  currentFlowUuid: string | null;
  currentUcCdnUrl: string | null;
  currentUcMimeType: string | null;
  isInUseForCardType: boolean;
}

export const useSessionStorageData = (cardType?: string): SessionData => {
  const [currentFlowUuid, setCurrentFlowUuid] = useState(null);
  const [currentUcCdnUrl, setCurrentUcCdnUrl] = useState(null);
  const [currentUcMimeType, setCurrentUcMimeType] = useState(null);
  /*
   * Since we don't persist the user choice on enabling the PLP Photo Preview feature
   * when having to check for the different values like the CDN url or the Flow UUID
   * we need to assume the feature is ON by default, until useEffect is triggered
   * with the proper card type to effectively confirm the feature status - or not - for the
   * current card type, based on the session storage values.
   *
   * This is especially needed for triggering tracking events at the right time
   * and avoid multiple triggers.
   */
  const [isInUseForCardType, setIsInUseForCardType] = useState(true);

  useEffect(() => {
    const sessionData = window.sessionStorage.getItem(ZOLA_PLP_PHOTO_PREVIEW);
    const currentPlpPhotoPreviewInUseByCardType =
      (typeof sessionData === 'string' && JSON.parse(sessionData)) || {};

    if (cardType) {
      if (currentPlpPhotoPreviewInUseByCardType[cardType]) {
        const {
          UcCdnUrl = null,
          UcMimeType = null,
          flowUuid = null,
        } = currentPlpPhotoPreviewInUseByCardType[cardType];

        if (SUPPORTED_CARD_TYPES.includes(cardType)) {
          setCurrentFlowUuid(flowUuid);
          setCurrentUcCdnUrl(UcCdnUrl);
          setCurrentUcMimeType(UcMimeType);
        }
      } else {
        setIsInUseForCardType(false);
      }
    }
  }, [cardType]);

  return { currentFlowUuid, currentUcCdnUrl, currentUcMimeType, isInUseForCardType };
};
